module.exports = __webpack_public_path__ + "static/media/dataak-logo.7d708e52.svg";